import React from "react";
import MfaContainer from "../containers/MfaContainer";

export const MfaPage: React.FunctionComponent = () => <MfaContainer />;